/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveSettings } from './LeaveSettings';
import {
    LeaveSettingsFromJSON,
    LeaveSettingsFromJSONTyped,
    LeaveSettingsToJSON,
    LeaveSettingsToJSONTyped,
} from './LeaveSettings';

/**
 * 
 * @export
 * @interface ShowLeaveSettingsResponse
 */
export interface ShowLeaveSettingsResponse {
    /**
     * 
     * @type {LeaveSettings}
     * @memberof ShowLeaveSettingsResponse
     */
    data: LeaveSettings;
}

/**
 * Check if a given object implements the ShowLeaveSettingsResponse interface.
 */
export function instanceOfShowLeaveSettingsResponse(value: object): value is ShowLeaveSettingsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowLeaveSettingsResponseFromJSON(json: any): ShowLeaveSettingsResponse {
    return ShowLeaveSettingsResponseFromJSONTyped(json, false);
}

export function ShowLeaveSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowLeaveSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveSettingsFromJSON(json['data']),
    };
}

  export function ShowLeaveSettingsResponseToJSON(json: any): ShowLeaveSettingsResponse {
      return ShowLeaveSettingsResponseToJSONTyped(json, false);
  }

  export function ShowLeaveSettingsResponseToJSONTyped(value?: ShowLeaveSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveSettingsToJSON(value['data']),
    };
}

